// import { UPDATE_SETTING, GET_LEAD_STATUS, ADD_LEAD_STATUS, UPDATE_LEAD_STATUS, GET_ALL_MESSAGE, DELETE_LEAD_STATUS, GET_SETTING, CREATE_WHATSAPP_MESSAGE, GET_ALL_WHATSAPP_MESSAGE, DELETE_WHATSAPP_MESSAGE, UPDATE_WHATSAPP_MESSAGE, GET_WHATSAPP_BYID, ADD_LEAD_FROM, GET_LEAD_FROM, UPDATE_LEAD_FROM, DELETE_LEAD_FROM, MANAGE_AUTO_ASSIGN, GET_ALL_LEAD_FROM } from "../actions/Setting.action";
import {
    UPDATE_SETTING,
    GET_LEAD_STATUS,
    ADD_LEAD_STATUS,
    UPDATE_LEAD_STATUS,
    GET_ALL_MESSAGE,
    DELETE_LEAD_STATUS,
    GET_SETTING,
    CREATE_WHATSAPP_MESSAGE,
    GET_ALL_WHATSAPP_MESSAGE,
    DELETE_WHATSAPP_MESSAGE,
    UPDATE_WHATSAPP_MESSAGE,
    GET_WHATSAPP_BYID,
    ADD_LEAD_FROM,
    GET_LEAD_FROM,
    UPDATE_LEAD_FROM,
    DELETE_LEAD_FROM,
    MANAGE_AUTO_ASSIGN,
    GET_ALL_LEAD_FROM,
    // 👇 Email Template Actions
    CREATE_EMAIL_TEMPLATE,
    GET_ALL_EMAIL_TEMPLATES,
    GET_EMAIL_TEMPLATE_BY_ID,
    UPDATE_EMAIL_TEMPLATE,
    DELETE_EMAIL_TEMPLATE,
    SET_ALL_EMAIL_TEMPLATES, // ✅ Add this line
    GET_CONFIGURATION_STATUS,
    ADD_CONFIGURATION_STATUS,
    UPDATE_CONFIGURATION_STATUS,
    DELETE_CONFIGURATION_STATUS,
} from "../actions/Setting.action";

const initialState = {
    updateSetting: '',
    getSetting: '',
    leadStatuses: [],
    configurationStatuses: [],
    configurationTotalPages: 1,
    totalPages: 1,
    createWhatsAppMessage: '',
    getAllWhatsAppMessage: '',
    deleteWhatsAppMessage: '',
    updateWhatsAppMessage: '',
    getWhatsAppById: '',
    getAllMessage: '',
    leadFroms: '',
    getLeadFroms: '',
    updateLeadFrom: '',
    deleteLeadFrom: '',
    autoAssignStatus: '',
    getAllLeadFrom: '',
    emailTemplates: [],
    getAllEmailTemplates: '',
    createEmailTemplate: '',
    getEmailTemplateById: '',
    updateEmailTemplate: '',
    deleteEmailTemplate: '',
}

const settingreducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SETTING:
            return { ...state, updateSetting: action.payload };
        case GET_SETTING:
            return { ...state, getSetting: action.payload };
        case GET_LEAD_STATUS:
            return {
                ...state,
                leadStatuses: action.payload.leadStatuses,
                totalPages: action.payload.totalPages
            };
        case ADD_LEAD_STATUS:
            return { ...state, leadStatuses: [...state.leadStatuses, action.payload] };
        case UPDATE_LEAD_STATUS:
            return {
                ...state,
                leadStatuses: state.leadStatuses.map((status) =>
                    status._id === action.payload._id ? action.payload : status
                ),
            };
        case DELETE_LEAD_STATUS:
            return {
                ...state,
                leadStatuses: state.leadStatuses.filter((status) => status._id !== action.payload),
            };
        case GET_CONFIGURATION_STATUS: {
            const configurationStatuses =
                (Array.isArray(action.payload?.configurationStatuses) && action.payload.configurationStatuses) ||
                (Array.isArray(action.payload?.voiceAIStatus) && action.payload.voiceAIStatus) ||
                (Array.isArray(action.payload?.data) && action.payload.data) ||
                [];
            const configurationTotalPages = action.payload?.totalPages
                ?? action.payload?.pagination?.totalPages
                ?? state.configurationTotalPages
                ?? 1;
            return {
                ...state,
                configurationStatuses,
                configurationTotalPages,
            };
        }
        case ADD_CONFIGURATION_STATUS: {
            const fallbackStatuses = Array.isArray(state.configurationStatuses) ? state.configurationStatuses : [];
            const updatedStatuses =
                (Array.isArray(action.payload?.voiceAIStatus) && action.payload.voiceAIStatus) ||
                (Array.isArray(action.payload?.configurationStatuses) && action.payload.configurationStatuses) ||
                null;
            const newStatus = action.payload?.data ?? action.payload;
            return {
                ...state,
                configurationStatuses: updatedStatuses ?? [...fallbackStatuses, newStatus],
            };
        }
        case UPDATE_CONFIGURATION_STATUS: {
            const fallbackStatuses = Array.isArray(state.configurationStatuses) ? state.configurationStatuses : [];
            const updatedStatuses =
                (Array.isArray(action.payload?.voiceAIStatus) && action.payload.voiceAIStatus) ||
                (Array.isArray(action.payload?.configurationStatuses) && action.payload.configurationStatuses) ||
                null;
            return {
                ...state,
                configurationStatuses: updatedStatuses ?? fallbackStatuses.map((status) =>
                    status._id === action.payload?._id ? action.payload : status
                ),
            };
        }
        case DELETE_CONFIGURATION_STATUS: {
            const fallbackStatuses = Array.isArray(state.configurationStatuses) ? state.configurationStatuses : [];
            const updatedStatuses =
                (Array.isArray(action.payload?.voiceAIStatus) && action.payload.voiceAIStatus) ||
                (Array.isArray(action.payload?.configurationStatuses) && action.payload.configurationStatuses) ||
                null;
            if (updatedStatuses) {
                return { ...state, configurationStatuses: updatedStatuses };
            }
            const payloadId = typeof action.payload === 'string' ? action.payload : action.payload?._id;
            return {
                ...state,
                configurationStatuses: fallbackStatuses.filter((status) => status._id !== payloadId),
            };
        }
        case CREATE_WHATSAPP_MESSAGE:
            return { ...state, createWhatsAppMessage: action.payload };
        case GET_ALL_WHATSAPP_MESSAGE:
            return { ...state, getAllWhatsAppMessage: action.payload };
        case DELETE_WHATSAPP_MESSAGE:
            return { ...state, deleteWhatsAppMessage: action.payload };
        case UPDATE_WHATSAPP_MESSAGE:
            return { ...state, updateWhatsAppMessage: action.payload };
        case GET_WHATSAPP_BYID:
            return { ...state, getWhatsAppById: action.payload };
        case GET_ALL_MESSAGE:
            return { ...state, getAllMessage: action.payload };
        case ADD_LEAD_FROM:
            return { ...state, leadFroms: action.payload }
        case GET_LEAD_FROM:
            return { ...state, getLeadFroms: action.payload };
        case UPDATE_LEAD_FROM:
            return { ...state, updateLeadFrom: action.payload };
        case DELETE_LEAD_FROM:
            return { ...state, deleteLeadFrom: action.payload };
        case MANAGE_AUTO_ASSIGN:
            return { ...state, autoAssignStatus: action.payload };
        case GET_ALL_LEAD_FROM:
            return { ...state, getAllLeadFrom: action.payload };

        // ✅ Email Template Reducer Cases
        case CREATE_EMAIL_TEMPLATE:
            return { ...state, createEmailTemplate: action.payload };
        case GET_ALL_EMAIL_TEMPLATES:
            return { ...state, emailTemplates: action.payload.data }; // ✅ not `action.payload`
        case GET_EMAIL_TEMPLATE_BY_ID:
            return { ...state, getEmailTemplateById: action.payload };
        case SET_ALL_EMAIL_TEMPLATES:
            return { ...state, getAllEmailTemplates: action.payload };

        case UPDATE_EMAIL_TEMPLATE:
            return {
                ...state,
                emailTemplates: state.emailTemplates.map((template) =>
                    template._id === action.payload._id ? action.payload : template
                ),
            };

        case DELETE_EMAIL_TEMPLATE:
            return {
                ...state,
                emailTemplates: state.emailTemplates.filter(
                    (template) => template._id !== action.payload
                ),
            };
        default:
            return state;
    }
}

export default settingreducer;